// languagetools:disable

import type { TChatChannel, TChatChannelResponse } from '@chain-zen/chat'

import type {
  IPostChatMetadata,
  IPrivatePostWithOffers,
  IPublicPostData,
  IPublicPostWithOffers
} from '../../../types/post'

export function getChatPostMetadata(
  post: IPublicPostWithOffers | IPrivatePostWithOffers | IPublicPostData
): IPostChatMetadata {
  return {
    commodity: post?.commodity || null,
    id: post?.id,
    loadNumber: post?.loadNumber || null,
    stops: post?.stops
      ? post.stops.map((stop) => {
          return {
            appointment: stop.appointment
              ? {
                  end: stop.appointment?.end || null,
                  isFirstComeFirstServe: stop.appointment?.isFirstComeFirstServe || false,
                  start: stop.appointment?.start || null
                }
              : null,
            type: stop.type || null,
            warehouse: {
              address: {
                city: stop.warehouse?.address?.city || null,
                stateCode: stop.warehouse?.address?.stateCode || null
              }
            }
          }
        })
      : null,
    truckTypes: post?.truckType || null,
    weight: post?.weight ? post.weight : null,
    workspace: post?.workspace || null
  }
}

export const syncPostDataInPostOfferChatMetadata = async ({
  postChannel,
  chatPostMetadata
}: {
  chatPostMetadata: IPostChatMetadata
  postChannel: TChatChannel
}) => {
  const channelDetail = postChannel.data?.channel_detail

  if (chatPostMetadata && channelDetail && JSON.stringify(channelDetail.post) !== JSON.stringify(chatPostMetadata)) {
    await postChannel.updatePartial({
      set: {
        'channel_detail.post': chatPostMetadata
      } as unknown as TChatChannelResponse
    })
  }
}
